export default {
  ALL_UPDATES: 'ALL_UPDATES',
  ALIGNER_UPDATES: 'ALIGNER_UPDATES',
} as const
